import { ApiError } from 'src/config/request/fetcher/error';
import { DataHubService } from 'src/core/services/datahub';
import { TryPageCreateSchema } from 'src/core/services/datahub/schemas/content/tryPageCreateSchema';
import { TryPagePublishSchema } from 'src/core/services/datahub/schemas/content/tryPagePublishSchema';
import { TryPageUpdateSchema } from 'src/core/services/datahub/schemas/content/tryPageUpdateSchema';
const schemas = {
    publish: TryPagePublishSchema,
    create: TryPageCreateSchema,
    update: TryPageUpdateSchema
};
function dispatchSubmitDatahubEvents({ response, error, action, pageId, payload, createNextEnable }) {
    const Schema = schemas[action];
    const statusCode = error instanceof ApiError ? error?.statusCode : response?.request.status;
    DataHubService.sendEvent({
        schema: new Schema({
            statusCode,
            pageId: pageId,
            createNextEnable,
            result: error ? 'FAILURE' : 'SUCCESSFUL',
            hasTag: Boolean(payload.tags?.length),
            hasText: Boolean(payload.page?.content),
            hasMedia: Boolean(payload.mediaIdList?.length),
            hasFile: Boolean(payload.attachmentIdList?.length),
            hasUrl: Boolean(payload.complementaryReadings?.length),
            hasDripping: Boolean(payload.page?.drippingConfigs?.length),
            failureDescription: error?.message ?? 'NOT_FAILURE_RESULT_EVENT'
        })
    });
}
export default dispatchSubmitDatahubEvents;
